import React from 'react';
import Card from './card';
import LanguageSwitcher from '../../../components/LanguageSwitcher';
import { useTranslation } from 'react-i18next';

const AppLogin = () => {
  const { t } = useTranslation();
  
  return (
    <div className='min-h-screen flex flex-col items-center justify-center bg-[radial-gradient(ellipse_at_top_left,_var(--tw-gradient-stops))] from-secondary via-accent to-secondary md:relative'>
      <div className='top-10 right-10 absolute'>
        <LanguageSwitcher />
      </div>
      <div className='p-10 md:p-0'> 
        <Card t={t} />
      </div>
    </div>
  );
};

export default AppLogin;
